module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_10",
    attrs: {
      "id": "calibre_pb_8"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "id": "id_Hlk76416756"
    }
  }, [_vm._v("Author’s Note")]), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }, [_vm._v("Each part contains a clue.")]), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }, [_vm._v("Each clue tells a story.")]), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }, [_vm._v("Each story unravels the mystery.")]), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_13"
  }, [_vm._v("Bloodson Bay is a haunted town. A cursed town. A plague to all who live here. As with all curses, there was a beginning. And we’re all still waiting for the wretched end.")]), _vm._v(" "), _c('p', {
    staticClass: "block_6"
  }, [_vm._v("It all began with one man and a heart broken so deep that the crack spread across time, across generations, to break many more.")]), _vm._v(" "), _c('p', {
    staticClass: "block_6"
  }, [_vm._v("In the year 1817, Reginald Bloodson, bursting in equal measure with youthful idealism and wanderlust, left Adams County, Ohio, and journeyed southward, with no particular destination in mind. Traveling sometimes by boat, sometimes by horseback, he arrived one glorious April morning upon the coastal plains of the great state of North Carolina, and knew he had found his home at last. ")]), _vm._v(" "), _c('p', {
    staticClass: "block_6"
  }, [_vm._v("He set about farming the rich black soil, and in his first year yielded a bountiful harvest of corn, wheat, cucumbers, and potatoes. News of this fertile region spread, luring more pilgrims like Reginald from far and wide. And Reginald welcomed all. ")]), _vm._v(" "), _c('p', {
    staticClass: "block_6"
  }, [_vm._v("In two years’ time the town had twenty-five houses, a blacksmith shop, and a general store. The next year it added a law office, two doctors’ offices, and a one-room schoolhouse. After four years the town proudly boasted two houses of worship, and a splendid courthouse was under construction. ")]), _vm._v(" "), _c('p', {
    staticClass: "block_6"
  }, [_vm._v("Life was good. And Reginald Bloodson was at the center of it all. ")]), _vm._v(" "), _c('p', {
    staticClass: "block_6"
  }, [_vm._v("In all the hustle and bustle, the naming of the burgeoning town had been put aside. All suggestions were considered, but when it was put to a vote, there was only one logical choice, and all the settlers agreed. The town was christened Bloodson Bay, in Reginald Bloodson’s honor. He was pleased. ")]), _vm._v(" "), _c('p', {
    staticClass: "block_6"
  }, [_vm._v("One day a new face arrived, a beautiful face, a gentle face, and Reginald instantly fell in love with this girl. He’d pass by her at the newly erected general store and gaze at her. He’d spy her across the church aisle and smile. Then one day she approached him and spoke to him. It took several awkward moments before he found the voice to respond, but she adored his shyness as much as he adored her kindness. And soon they were constant companions. ")]), _vm._v(" "), _c('p', {
    staticClass: "block_6"
  }, [_vm._v("With her in possession of his heart, he built a house for her on the cliff overlooking the bay, and he took the girl to see it and proposed to her upon bended knee. Her kiss was all he needed to know that she loved him as much as he loved her. ")]), _vm._v(" "), _c('p', {
    staticClass: "block_6"
  }, [_vm._v("Together they began their family, creating a home, enjoying sunrises from their ocean view hideaway, and watching their land flourish. One baby after the next, their tiny family grew as they added one, two, three, then four children, all boys, to their happy little fold. While pregnant with the fifth, his beloved wife warned Reginald that if anything were to happen to her, he should raise the boys to be compassionate and loving like he was. He agreed; of course he agreed to her every request as he caressed her cheek. ")]), _vm._v(" "), _c('p', {
    staticClass: "block_6"
  }, [_vm._v("But during the birth of his fifth boy, a fateful June 27th, his wife died during childbirth. While the baby survived, Reginald found he could no longer keep his promise. His crops wilted. His home deteriorated. And his heart cracked more each day. He grew to resent, then hate that fifth child that stole his beloved’s life…and soon that hatred spilled and spread to all his children for what had become of his life. He withered into a wretched man, stooped and shrunken, filled with anguish and despair.")]), _vm._v(" "), _c('p', {
    staticClass: "block_6"
  }, [_vm._v("On the one-year anniversary of his wife’s death, he could no longer look at his children, for they wore his beloved’s eyes, her nose, her lips, her smile. So he led them to the cliff’s edge to watch the sunrise one last time. Then one by one, he pushed his sons into the watery abyss below. Then he himself leaped onto the jagged rocks, and at last his broken body joined his broken spirit. ")]), _vm._v(" "), _c('p', {
    staticClass: "block_6"
  }, [_vm._v("That day, the blood of the children stained Bloodson Bay red. The townsfolk saw this as grimly ironic, that the sanguine name of their founder had proven so prophetic.")]), _vm._v(" "), _c('p', {
    staticClass: "block_6"
  }, [_vm._v("Yet one child survived the fall. He grew up to continue his father’s legacy, eventually building a family of his own. A family cursed with death. You see, every year on the anniversary of his father’s death, the townspeople felt the haunting. The pull of the cliff. And for decades after, pain plagued that very day: June 27. ")]), _vm._v(" "), _c('p', {
    staticClass: "block_6"
  }, [_vm._v("Then, one day in 1986, the curse came for a young mother…and it would pull her toward that watery abyss, and eventually to her grave.")]), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }, [_vm._v("**")]), _vm._v(" "), _c('p', {
    staticClass: "block_15"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_13"
  }, [_c('span', {
    staticClass: "text_3"
  }, [_vm._v("Curious to know what ")]), _c('b', {
    staticClass: "calibre3"
  }, [_vm._v("really")]), _c('span', {
    staticClass: "text_3"
  }, [_vm._v(" happened to the original founding family? Click to read the origin story of the Bloodson Bay curse:")])]), _vm._v(" "), _c('p', {
    staticClass: "block_16"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_c('a', {
    staticClass: "calibre2",
    attrs: {
      "href": "http://mybook.to/IOSK",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text_4"
  }, [_vm._v("If Only She Knew")])])]), _vm._v(" "), _c('p', {
    staticClass: "block_15"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_6"
  }, [_c('span', {
    staticClass: "calibre4"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5de6564","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_006.vue
// module id = 75
// module chunks = 0